<template>
  <div class='disponibilite'>
    <div class='inner' :style='styles' :class="{ 'selected': week.anneeSemaine === weekSelect }">
        <span>{{ nbFaceDispo }} / {{ week.stock}}</span>
    </div>
  </div>
</template>

<script>
import calculateStyleCelluleEtatObtenu from '@/services/planningReseauTempo/calculateStyleCelluleEtatObtenu';

export default {
  props: {
    week: Object,
    weekSelect: Number,
    devisCommande: Object,
  },
  computed: {
    nbFaceDispo() {
      let nbFacesNonDispo = 0;
      if (this.week.allAffectationOfProduct.length === 0) return this.week.stock;

      this.week.allAffectationOfProduct
        .filter((affectation) => {
          return affectation.referenceId !== this.devisCommande.id
            && affectation.rangOption === null;
        })
        .forEach((affectationReseauTempo) => {
          nbFacesNonDispo += affectationReseauTempo.nbFaces;
        });

      return this.week.stock - nbFacesNonDispo;
    },
    styles() {
      const weekInformation = {
        allAffectationOfProduct: this.week.allAffectationOfProduct
          .filter((affectation) => {
            return affectation.referenceId !== this.devisCommande.id;
          }),
        stock: this.week.stock,
      };
      return calculateStyleCelluleEtatObtenu(weekInformation);
    },
  },
};
</script>
